import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
// import FPolicyBuilderDrawer2 from '@/components/FPolicyBuilderDrawer2';
import FPolicyBuilderDrawer3 from './FPolicyBuilderDrawer3';
import { FUtil } from '@freelog/tools-lib';
import { PolicyTemplateInfo } from './FPolicyBuilderDrawer3/PolicyTemplates';

interface fPolicyBuilder3Props {
  alreadyUsedTitles?: string[];
  alreadyUsedTexts?: string[];
  defaultValue?: PolicyTemplateInfo;
  nodeID?: number;
  resourceTypeCode?: string[];
}

type ReturnData = { title: string; text: string } | null;

function fPolicyBuilder3({
  alreadyUsedTitles,
  alreadyUsedTexts,
  defaultValue,
  nodeID,
  resourceTypeCode=[],
}: fPolicyBuilder3Props): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <Temp
        alreadyUsedTitles={alreadyUsedTitles}
        alreadyUsedTexts={alreadyUsedTexts}
        defaultValue={defaultValue}
        nodeID={nodeID}
        resourceTypeCode={resourceTypeCode}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
        onConfirm={(value: { title: string; text: string }) => {
          resolve(value);
        }}
      />,
    );
  });
}

export default fPolicyBuilder3;

interface TempProps {
  alreadyUsedTitles?: string[];
  alreadyUsedTexts?: string[];
  nodeID?: number;
  resourceTypeCode: string[];
  defaultValue?: PolicyTemplateInfo;

  onConfirm?({ title, text }: { title: string; text: string }): void;

  onClose?(): void;
}

function Temp({
  alreadyUsedTitles,
  alreadyUsedTexts,
  nodeID,
  resourceTypeCode,
  defaultValue,
  onConfirm,
  onClose,
}: TempProps) {
  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(true);

  return (
    <FPolicyBuilderDrawer3
      open={$open}
      alreadyUsedTitles={alreadyUsedTitles}
      alreadyUsedTexts={alreadyUsedTexts}
      nodeID={nodeID}
      resourceTypeCode={resourceTypeCode}
      defaultValue={defaultValue}
      onConfirm={(value) => {
        onConfirm && onConfirm(value);
        set$open(false);
      }}
      onCancel={() => {
        set$open(false);
      }}
      afterVisibleChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
    />
  );
}
